import { useState } from "react";
import { Users2, BellRing, History } from "lucide-react";
import MembershipAdmins from "@/components/MembershipAdmins";
import MembershipNotices from "@/components/MembershipNotices";
import MembershipHistory from "@/components/MembershipHistory";

const TABS = [
  { id: "admins", label: "Administradores", icon: Users2 },
  { id: "notices", label: "Avisos", icon: BellRing },
  { id: "history", label: "Historial", icon: History },
];

export default function MembershipCenter({ groups, reload }) {
  const [tab, setTab] = useState("admins");

  return (
    <div className="space-y-6" data-testid="membership-center">
      <div>
        <span className="overline text-gold">Solo propietario/admins autorizados</span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold">Centro de Administración y Membresías</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Contactos de renovación, avisos de vencimiento por grupo e historial de envíos. Esta sección no
          modifica el escáner, la Liga Leyenda, la guerra ni el Capital.
        </p>
      </div>

      <div className="flex gap-2 border-b border-white/10 overflow-x-auto" data-testid="membership-tabs">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.id;
          return (
            <button
              key={t.id}
              data-testid={`membership-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-all whitespace-nowrap ${
                active ? "border-gold text-gold" : "border-transparent text-muted-foreground hover:text-white"
              }`}
            >
              <Icon size={16} /> {t.label}
            </button>
          );
        })}
      </div>

      {tab === "admins" && <MembershipAdmins />}
      {tab === "notices" && <MembershipNotices groups={groups} reload={reload} />}
      {tab === "history" && <MembershipHistory groups={groups} />}
    </div>
  );
}
